import { render } from "./CoreGoalMetrics.vue?vue&type=template&id=c7468006&scoped=true"
import script from "./CoreGoalMetrics.vue?vue&type=script&lang=js"
export * from "./CoreGoalMetrics.vue?vue&type=script&lang=js"

import "./CoreGoalMetrics.vue?vue&type=style&index=0&id=c7468006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7468006"]])

export default __exports__